import { validationIsEqual, validationActionTypeisEqual } from '../status';
import {
    validateAlphaNumericString,
    validateStreetWithNumber,
    validateEmail,
    validateName,
    validateContactNumber,
    validateSingleSelection,
    validateDate,
    validateNumber,
    validateLoanTerm,
    validatePassportNumber,
    validatePostalAddress,
    validateAlphaString,
    validateAccountNumber,
    validateDateOfBirth,
    validateStreetAddress,
} from '@om/validation';

import { validateBwIdNumber } from '@om/validation/src/validators/bw-id-number-validator';
import { setClaimentDetailsFieldValid } from '../../../actions/sizotsaFuneralClaim/claimentDetails';
import { validateNameVTwo } from '@om/validation/src/validators/string-validator';
import { getClaimentDetailsForm } from '../../../selectors/sizotsaFuneralClaim/claimentDetails';
import { validateEmailAddress } from '@om/validation/src/validators/email-validator';
import { validateSzIdNumber } from '@om/validation/src/validators/eswatini-id-number-validator';

let prevValidationAction = null;
export const claimentDetailsValidation = (store, next, action) => {
    const validationAction = (() => {
        const trimValue = (value) => (value ? value.trim() : value);
        const { claimentType, idSelected,title,dateOfBirth } = getClaimentDetailsForm(store.getState());
        let error;

        const returnError = (type, validationFunction, value, validationObject) => {
            error =
                type !== 'Policy holder'
                    ? validationFunction(value, { ...validationObject, required: 'true' })
                    : value !== ''
                    ? validationFunction(value, { ...validationObject, required: 'false' })
                    : null;
            return error;
        };
        switch (action.value.fieldType) {
            // Personal details
            //   case TITLE_SET_VALUE:
            //     error = validateSingleSelection(action.value.value, "Title");
            //     return setTitleValid(error);
            case 'claimentType':
                error = validateSingleSelection(action.value.value, 'Claiment Type');
                return setClaimentDetailsFieldValid(error, action.value.fieldType);

            case 'title':
                error = validateSingleSelection(action.value.value, 'Title');
                return setClaimentDetailsFieldValid(error, action.value.fieldType);
            case 'firstName':
                error = validateNameVTwo(trimValue(action.value.value), {
                    min: 3,
                    max: 66,
                    subject: 'First name',
                });
                return setClaimentDetailsFieldValid(error, action.value.fieldType);
            case 'middleName':
                error = validateName(trimValue(action.value.value), {
                    min: 3,
                    max: 66,
                    subject: 'Middle name',
                    required: false,
                });
                return setClaimentDetailsFieldValid(error, action.value.fieldType);
            case 'lastName':
                error = validateNameVTwo(trimValue(action.value.value), {
                    min: 3,
                    max: 66,
                    subject: 'Last name',
                });
                return setClaimentDetailsFieldValid(error, action.value.fieldType);

            case 'dateOfBirth':
                error = validateDateOfBirth(action.value.value, {
                    subject: 'Date of birth',
                    required: true,
                });
                return setClaimentDetailsFieldValid(error, action.value.fieldType);

            case 'policyNumber':
                error = validateNumber(action.value.value, { 
                    subject: 'Policy number',
                    required:false
                });
                return setClaimentDetailsFieldValid(error, action.value.fieldType);

            case 'idNumber':
                error = validateBwIdNumber(action.value.value, {
                    required: true,
                    subject: 'ID number',
                    gender: 'Male',
                });
                return setClaimentDetailsFieldValid(error, action.value.fieldType);

            case 'relationshipToPolicyHolder':
                error = validateAlphaString(action.value.value, {
                    min: 2,
                    max: 25,
                    subject: 'Relationship',
                });
                return setClaimentDetailsFieldValid(error, action.value.fieldType);
            case 'isAccountHolder':
                error = validateSingleSelection(action.value.value, 'Account holder');
                return setClaimentDetailsFieldValid(error, action.value.fieldType);
            case 'nationality':
                error = validateSingleSelection(action.value.value, 'Nationality');
                return setClaimentDetailsFieldValid(error, action.value.fieldType);

            // -------------------------Address Validation
            case 'streetAddress':
                error = validateStreetWithNumber(trimValue(action.value.value), {
                    min: 3,
                    max: 75,
                    subject: 'Street Address',
                });
                return setClaimentDetailsFieldValid(error, action.value.fieldType);
            case 'city':
                error = validateStreetAddress(trimValue(action.value.value), {
                    min: 1,
                    max: 75,
                    subject: 'city',
                });
                return setClaimentDetailsFieldValid(error, action.value.fieldType);
            case 'country':
                error = validateSingleSelection(action.value.value, 'Country');
                return setClaimentDetailsFieldValid(error, action.value.fieldType);

            case 'residenceTimePeriod':
                error = validateSingleSelection(action.value.value, 'Residence year');
                return setClaimentDetailsFieldValid(error, action.value.fieldType);

            case 'previousPostalAddress':
                error = validateStreetWithNumber(action.value.value, {
                    min: 3,
                    max: 75,
                    required: true,
                    subject: 'Previous residential address',
                });
                return setClaimentDetailsFieldValid(error, action.value.fieldType);

            case 'previousPostalCity':
                error = validateStreetAddress(trimValue(action.value.value), {
                    min: 1,
                    max: 75,
                    subject: 'Previos city',
                });
                return setClaimentDetailsFieldValid(error, action.value.fieldType);

            case 'previousPostalCountry':
                error = validateSingleSelection(action.value.value, ' Previous residential Country');
                return setClaimentDetailsFieldValid(error, action.value.fieldType);

            case 'postalSuburb':
                error = validatePostalAddress(action.value.value, {
                    min: 3,
                    max: 75,
                    required: false,
                    subject: 'Postal Suburb',
                });
                return setClaimentDetailsFieldValid(error, action.value.fieldType);

            case 'postalCity':
                error = validateStreetAddress(trimValue(action.value.value), {
                    min: 1,
                    max: 75,
                    required: false,
                    subject: 'Postal city',
                });
                return setClaimentDetailsFieldValid(error, action.value.fieldType);

            case 'postalCountry':
                error = validateSingleSelection(action.value.value, ' Previous postal Country');
                return setClaimentDetailsFieldValid(error, action.value.fieldType);
            case 'district':
                error = validateSingleSelection(action.value.value, 'District');
                return setClaimentDetailsFieldValid(error, action.value.fieldType);

            case 'residentialDuration':
                error = validateSingleSelection(action.value.value, 'Residential duration');
                return setClaimentDetailsFieldValid(error, action.value.fieldType);
            case 'idSelected':
                error = validateSingleSelection(action.value.value, 'Select ID');
                return setClaimentDetailsFieldValid(error, action.value.fieldType);
            case 'accountHolderId':
                error =
                    idSelected?.value === '01'
                        ? validateSzIdNumber(action.value.value, {
                              required: true,
                              subject: `'Eswatini ID number`,
                              gender: title?.value === 'Mr.' ? 'Male' : 'Female',
                              dateOfBirth:dateOfBirth?.value
                          })
                        : validatePassportNumber(action.value.value, {
                              required: true,
                              subject: `'Passport ID number`,
                          });
                return setClaimentDetailsFieldValid(error, action.value.fieldType);

            //Contact Details
            case 'email':
                error = validateEmailAddress(trimValue(action.value.value), {
                    min: 10,
                    max: 60,
                    subject: 'Email address',
                    required: true,
                });
                return setClaimentDetailsFieldValid(error, action.value.fieldType);
            case 'mobileNumber':
                error = validateContactNumber(action.value.value, {
                    countryCode: 'sz',
                    leadingZeroValidation: false,
                    required: true,
                });
                return setClaimentDetailsFieldValid(error, action.value.fieldType);

            //----->Dependent Optional Field--> Bank Details
            case 'accountHolderName':
                error = returnError(claimentType?.displayValue, validateName, trimValue(action.value.value), {
                    min: 2,
                    max: 25,
                    subject: 'Account holder name',
                    required: false,
                });
                return setClaimentDetailsFieldValid(error, action.value.fieldType);

            case 'bank':
                error = validateSingleSelection(action.value.value, 'Bank');
                return setClaimentDetailsFieldValid(error, action.value.fieldType);
            case 'bankBranch':
                error = validateSingleSelection(action.value.value, 'Bank branch');
                return setClaimentDetailsFieldValid(error, action.value.fieldType);    
            case 'accountNumber':
                error = returnError(claimentType?.displayValue, validateAccountNumber, action.value.value, {
                    min: 5,
                    max: 13,
                });
                return setClaimentDetailsFieldValid(error, action.value.fieldType);

            case 'accountType':
                error = validateSingleSelection(action.value.value, 'Account type');
                return setClaimentDetailsFieldValid(error, action.value.fieldType);
            case 'employeeOccupation':
                error = validateSingleSelection(action.value.value, 'Employee occupation');
                return setClaimentDetailsFieldValid(error, action.value.fieldType);

            case 'otherEmployeeOccupation':
                error = validateAlphaNumericString(trimValue(action.value.value), {
                    min: 2,
                    max: 25,
                    subject: 'other occupation',
                    required: true
                });
                return setClaimentDetailsFieldValid(error, action.value.fieldType);
            case 'employerName':
                error = validateAlphaNumericString(action.value?.value, {
                    min: 2,
                    max: 25,
                    required: false,
                    subject: 'Employer',
                });
                return setClaimentDetailsFieldValid(error, action.value.fieldType);
            case 'employerPlace':
                error = validateAlphaNumericString(action.value?.value, {
                    min: 2,
                    max: 25,
                    required: false,
                    subject: 'Employer place',
                });
                return setClaimentDetailsFieldValid(error, action.value.fieldType);

            default:
                return null;
        }
    })();

    if (!validationAction || validationActionTypeisEqual(validationAction, prevValidationAction)) {
        return next(action);
    }

    store.dispatch(validationAction);
    prevValidationAction = validationAction;
    return next(action);
};
